import axios from 'axios'
import eventHub from '../eventhub'

axios.interceptors.request.use(function (config) {
  const user = localStorage.getItem('user')
  const token = user ? JSON.parse(user)?.token : ''

  config.baseURL = process.env.VUE_APP_API_URL

  config.headers[process.env.VUE_APP_API_TOKEN_HEADER] =
    `${process.env.VUE_APP_API_TOKEN_PREFIX ?? ''} ${token}`.trim()

  return config
})

axios.interceptors.response.use(
  (config) => config,
  (error) => {
    if (!error && !error.response) {
      eventHub.$emit('error_503')
    }
    return Promise.reject(error)
  }
)

export default {
  install (Vue, options) {
    Vue.prototype.$axios = axios
  }
}
